import { render } from "./UnNftOwner.vue?vue&type=template&id=5f5a121d"
import script from "./UnNftOwner.vue?vue&type=script&lang=js"
export * from "./UnNftOwner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__